import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

const OrderDetails = () => {
    const [orders, setOrders] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");

    // Fetch Orders
    const fetchOrders = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}order/get-all`
            );
            const result = await response.json();

            if (result?.status_code === 200) {
                setOrders(result.result);
            } else {
                console.error("Failed to fetch orders:", result?.message);
            }
        } catch (error) {
            console.error("Error fetching orders:", error);
        }
    };

    useEffect(() => {
        fetchOrders();
    }, []);

    // Filtering
    const filteredOrders = orders.filter((order) => {
        const query = searchQuery.trim().toLowerCase();
        return (
            order.firstName?.toLowerCase().includes(query) ||
            order.lastName?.toLowerCase().includes(query) ||
            order.email?.toLowerCase().includes(query) ||
            order.orderId?.toLowerCase().includes(query)
        );
    });

    // Pagination
    const totalPages = Math.ceil(filteredOrders.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedOrders = filteredOrders.slice(
        startIndex,
        startIndex + itemsPerPage
    );

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };

    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };

    return (
        <div>
            {/* Breadcrumbs & Title */}
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
                <h6 className="fw-semibold mb-0">Order Details</h6>
                <ul className="d-flex align-items-center gap-2">
                    <li className="fw-medium">
                        <Link to="/" className="d-flex align-items-center gap-1 hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="icon text-lg" />
                            Dashboard
                        </Link>
                    </li>
                    <li> - </li>
                    <li className="fw-medium">Order Details</li>
                </ul>
            </div>

            <div className="card">
                <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <span>Show</span>
                        <select
                            className="form-select form-select-sm w-auto"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                        >
                            <option value="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                            <option value={filteredOrders.length}>All</option>
                        </select>
                    </div>

                    <div className="icon-field">
                        <input
                            type="text"
                            className="form-control form-control-sm w-auto"
                            placeholder="Search by Name, Email or OrderId"
                            onChange={handleSearchChange}
                        />
                        <span className="icon">
                            <Icon icon="ion:search-outline" />
                        </span>
                    </div>
                </div>

                <div className="card-body" style={{ overflowX: "auto" }}>
                    <table className="table bordered-table mb-0">
                        <thead>
                            <tr>
                                <th>S.L</th>
                                <th>Order Id</th>
                                <th>First Name</th>
                                <th>Last Name</th>
                                <th>Email Address</th>
                                <th>Mobile No</th>
                                <th>Number Of Product</th>
                                <th>Total Amount Pay</th>
                                <th>Order Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedOrders.length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        No orders found.
                                    </td>
                                </tr>
                            ) : (
                                paginatedOrders.map((order, index) => (
                                    <tr key={order.orderId}>
                                        <td>{startIndex + index + 1}</td>
                                        <td>{order.orderId}</td>
                                        <td>{order.firstName}</td>
                                        <td>{order.lastName}</td>
                                        <td>{order.email}</td>
                                        <td>{order.mobile}</td>
                                        <td>{order.numberOfProduct}</td>
                                        <td>{order.totalAmountPay}</td>
                                        <td>
                                            <span className="border border-payment-main px-24 py-4 radius-4 fw-medium text-sm">
                                                {order.orderStatus}
                                            </span>
                                        </td>
                                        <td>
                                            <Link to={`/order_details/${order.orderId}`}>
                                                <button
                                                    type="button"
                                                    className="bg-custom fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon
                                                        icon="majesticons:eye-line"
                                                        className="icon text-xl"
                                                    />
                                                </button>
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    <div className="d-flex justify-content-end align-items-center gap-4 mt-3">
                        <button
                            className="btn btn-sm"
                            onClick={handlePrev}
                            disabled={currentPage === 1}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                                height: "auto",
                            }}
                        >
                            Prev
                        </button>

                        <span>
                            Page {currentPage} of {totalPages || 1}
                        </span>

                        <button
                            className="btn btn-sm"
                            onClick={handleNext}
                            disabled={currentPage === totalPages || totalPages === 0}
                            style={{
                                backgroundColor: "#545454",
                                color: "white",
                                border: "none",
                                padding: "10px 40px",
                                height: "auto",
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderDetails;
